import React from 'react'
import { usePriceInfo } from 'src/hooks/usePriceInfo'

interface PriceTagProps {
  listPrice?: number
  price?: number
}

export function InsiderPriceTag({ listPrice, price }: PriceTagProps) {
  const {
    hasDiscount,
    discountPercent,
    formattedListPrice,
    formattedPrice,
  } = usePriceInfo(listPrice, price)

  return (
    <div className="product-price-wrapper">
      {hasDiscount && discountPercent && (
        <div className="discount-flag">-{discountPercent}%</div>
      )}
      {hasDiscount && formattedListPrice && formattedPrice ? (
        <div className="product-price">
          <span className="old-price">R$ {formattedListPrice}</span>
          <span className="new-price">R$ {formattedPrice}</span>
        </div>
      ) : formattedPrice ? (
        <div className="product-price">
          <span className="single-price">R$ {formattedPrice}</span>
        </div>
      ) : (
        <div className="product-price">
          <span className="no-price">Preço indisponível</span>
        </div>
      )}
    </div>
  )
}
